import { useEffect, useState } from "react";

// Ratchets a visible count up toward targetCount one step at a time (at most one
// increment per staggerMs), instead of jumping straight to it - e.g. so a checklist
// doesn't complete several rows at once when its source data skips a step.
// A target that moves *down* (the source resetting, e.g. the user removing their
// file) snaps immediately rather than staggering
export const useStaggeredCount = (
  targetCount: number,
  maxCount: number,
  staggerMs: number,
): number => {
  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    const clampedMax = Math.max(0, maxCount);
    const clampedTarget = Math.max(0, Math.min(targetCount, clampedMax));

    if (visibleCount > clampedTarget) {
      setVisibleCount(clampedTarget);
      return undefined;
    }

    if (visibleCount === clampedTarget) {
      return undefined;
    }

    const timeout = setTimeout(() => {
      setVisibleCount((prev) => Math.min(prev + 1, clampedMax));
    }, staggerMs);

    return () => clearTimeout(timeout);
  }, [targetCount, maxCount, staggerMs, visibleCount]);

  return visibleCount;
};
